import * as React from "react";

const Plus: React.FC = () => {
    return (
        <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.5 1.75V12.25M1.25 7H11.75" stroke="#A22E31" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>


    );
};

export default React.memo(Plus);
